var React = require('react');

function Consumption (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.818 1.318a4.5 4.5 0 017.675 2.94l17.36 5.105A4.506 4.506 0 0143.5 7.5a4.5 4.5 0 11-4.494 4.74L21.647 7.137A4.495 4.495 0 0118 9a4.499 4.499 0 01-1.526-.267l-8.126 9.933a4.5 4.5 0 11-2.322-1.9l8.126-9.932a4.5 4.5 0 01.666-5.516zm4.626 3.587l-.005.018-.005.018a1.5 1.5 0 11.01-.036zM43.5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-39 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm14.379-.621A3 3 0 0121 18h6a3 3 0 013 3v24h3V30a3 3 0 013-3h6a3 3 0 013 3v15h1.5a1.5 1.5 0 110 3h-45a1.5 1.5 0 010-3H3v-9a3 3 0 013-3h6a3 3 0 013 3v9h3V21a3 3 0 01.879-2.121zM21 45h6V21h-6v24zm-9 0v-9H6v9h6zm30 0V30h-6v15h6z"}));
}

Consumption.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Consumption;

Consumption.default = Consumption;
